import img1 from "../../Images/Proyectos/Galerias/Michel-Alvarez/1.png";
import img2 from "../../Images/Proyectos/Galerias/Michel-Alvarez/2.png";
import img3 from "../../Images/Proyectos/Galerias/Michel-Alvarez/3.png";
import img4 from "../../Images/Proyectos/Galerias/Michel-Alvarez/4.png";
import img5 from "../../Images/Proyectos/Galerias/Michel-Alvarez/5.png";
import img6 from "../../Images/Proyectos/Galerias/Michel-Alvarez/6.png";
import img7 from "../../Images/Proyectos/Galerias/Michel-Alvarez/7.png";
import img8 from "../../Images/Proyectos/Galerias/Michel-Alvarez/8.png";
import img9 from "../../Images/Proyectos/Galerias/Michel-Alvarez/9.png";

export const photos = [
    {
        src: img1,
        width: 6,
        height: 3
    },
    {
        src: img2,
        width: 4,
        height: 4
    },
    {
        src: img3,
        width: 4,
        height: 4
    },
    {
        src: img4,
        width: 6,
        height: 3
    },
    {
        src: img5,
        width: 4,
        height: 4
    },
    {
        src: img6,
        width: 4,
        height: 4
    },
    {
        src: img7,
        width: 4,
        height: 4
    },
    {
        src:img8,
        width: 4,
        height: 4
    },
    {
        src:img9,
        width: 6,
        height: 3
    }
  ];
  